<template>
  <ul class="suggestions" v-show="suggestions.length > 0">
    <li class="suggestions__hint">{{ $t("Homepage.AutosuggestResults.suggestions") }}:</li>
    <ResultItem
      v-for="result in suggestions"
      v-bind:key="result.slug"
      v-bind:result="result"
      v-bind:isActive="result == highlightedSuggestion" />
    <li class="suggestions__attribution">&copy; <a target="_blank" href='https://www.mapbox.com/about/maps/'>Mapbox</a></li>
  </ul>
</template>

<script>
import ResultItem from "@/components/SearchResults/ResultItem";

export default {
  components: { ResultItem },
  props: ["suggestions", "highlightedSuggestion"],
}
</script>


<style lang="scss" scoped>
  .suggestions {
    background: #fff;
    border: solid 1px #fff;
    border-top: 0;
    border-radius: 0 0 2px 2px;
    color: #212529;
    list-style: none;
    padding: 0;
    position: absolute;
    left: 15px;
    right: 15px;
    text-align: left;
    z-index: 10000;
  }

  .suggestions li {
    padding: 2px 4px;
  }

  .suggestions__hint {
    font-size: 0.8em;
    font-style: italic;
  }

  .suggestions__attribution {
    font-size: 0.6em;
    text-align: right;
  }

  .result-item {
    list-style: none;
    text-align: left;
  }
</style>



// WEBPACK FOOTER //
// src/components/Homepage/AutosuggestResults.vue